var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-tabbar',{attrs:{"route":""}},[_c('van-tabbar-item',{attrs:{"replace":"","icon":"home-o","to":"/index"}},[_vm._v("首页")]),_c('van-tabbar-item',{attrs:{"replace":"","icon":"desktop-o","to":"/analysis"}},[_vm._v("查询")]),_c('van-tabbar-item',{attrs:{"replace":"","icon":"contact","to":"/mine"}},[_vm._v("我的")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }